import { assertIsNumberOrNull } from '../../../helpers/numberHelpers';
import { SolarFormModel } from '../quote-or-design-form/solar/solarFormModel';
import { FixingKitTypeCode } from './fixingKitTypeCode';

export type CreateUpdateSolarDto = {
  fixingKitTypeCode: FixingKitTypeCode;
  assumedDomesticHotWaterDemandInLitresPerDay: number | null;
  solarPanelQuantity: number | null;
  solarInputInKilowattHoursPerYear: number | null;
  solarFractionPercentage: number | null;
  includingHotWaterCylinder: boolean;
};

export const mapSolarFormModelToDto = (formModel: SolarFormModel): CreateUpdateSolarDto => ({
  fixingKitTypeCode: formModel.fixingKitTypeCode,
  assumedDomesticHotWaterDemandInLitresPerDay: assertIsNumberOrNull(
    formModel.assumedDomesticHotWaterDemandInLitresPerDay,
  ),
  solarPanelQuantity: formModel.solarPanelQuantity,
  solarInputInKilowattHoursPerYear: assertIsNumberOrNull(formModel.solarInputInKilowattHoursPerYear),
  solarFractionPercentage: assertIsNumberOrNull(formModel.solarFractionPercentage),
  includingHotWaterCylinder: formModel.includingHotWaterCylinder,
});
